import React from 'react';
import iconify from '../iconify';

const ExitIcon = ({customColor, ...props}) => (
  <svg
    width="1em"
    height="1em"
    viewBox="5737.874 1393.684 23.416 20.832"
    {...props}
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="-0.425"
        y1="-0.053"
        x2="1"
        y2="-0.056"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d3793b" />
        <stop offset="1" stopColor="#ea4154" />
      </linearGradient>
    </defs>
    <g
      id="Group_714"
      data-name="Group 714"
      transform="translate(5737.874 1393.684)"
    >
      <path
        id="Path_291"
        data-name="Path 291"
        fill={customColor ? customColor : 'url(#linear-gradient)'}
        d="M12.531,19H3.671A1.857,1.857,0,0,1,1.836,17.16V3.671A1.857,1.857,0,0,1,3.671,1.836h8.9a.9.9,0,0,0,.918-.918A.937.937,0,0,0,12.531,0H3.671A3.662,3.662,0,0,0,0,3.671V17.16a3.662,3.662,0,0,0,3.671,3.671h8.9a.9.9,0,0,0,.918-.918A.937.937,0,0,0,12.531,19Z"
      />
      <path
        id="Path_292"
        data-name="Path 292"
        fill={customColor ? customColor : 'url(#linear-gradient)'}
        d="M28.713,12.194A.931.931,0,1,0,27.4,13.511L30.588,16.7H17.818a.918.918,0,1,0,0,1.836H30.309L27.4,21.413a.938.938,0,0,0,.639,1.6.978.978,0,0,0,.639-.319L33.3,18.061a.939.939,0,0,0,0-1.317Z"
        transform="translate(-10.156 -7.166)"
      />
    </g>
  </svg>
);

export default iconify(ExitIcon);
